export default __webpack_public_path__ + "static/media/icon_category-wedding-dress.1c59f482.svg";